import { Box, useScaleFactor, useTheme } from "arkh";
import {
  GraphBar,
  GraphLabel,
  WidgetTaskSingleGraphOccasion,
} from "../Graph/Graph";
import React, { useState } from "react";

export function GraphCheck(props: {
  data: {
    id: string;
    label: string;
    value: (boolean | null)[];
    isActive?: boolean;
  }[];
}) {
  const [totalGraphBarHeight, setGraphBarHeight] = useState(0);
  const sf = useScaleFactor();
  const graphBarHeight = totalGraphBarHeight - 40 * sf;

  const theme = useTheme();
  return (
    <Box
      style={{
        flexDirection: "row",
        height: "100%",
        width: "100%",
        flex: 1,
        position: "relative",
      }}
      onLayout={(e) => {
        setGraphBarHeight(e.nativeEvent.layout.height);
      }}
    >
      {props.data.map(({ id, label, value, isActive }) => (
        <WidgetTaskSingleGraphOccasion key={id}>
          <GraphBar
            height={graphBarHeight}
            emphasis={isActive}
            parts={value.map((v) => ({
              weight: 1,
              color:
                v === null
                  ? theme.background
                  : v
                  ? theme.positive
                  : theme.negative,
            }))}
          />
          <GraphLabel children={label} active={isActive} />
        </WidgetTaskSingleGraphOccasion>
      ))}
    </Box>
  );
}
